var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PowerBIReportViewer,{attrs:{"current-requester":_setup.CURRENT_REQUESTER,"page-title":"PBI Interno","page-subtitle":"Select workspace and reports","brand-label":"Brand"},on:{"workspace-changed":_setup.handleWorkspaceChange,"report-changed":_setup.handleReportChange,"brand-changed":_setup.handleBrandChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }